import usePageMeta from "utils/usePageMeta";
/* eslint-disable no-unused-vars */

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Layout
import SubPageLayout from "reusables/layouts/SubPageLayout";

// Sections
import Accommodation_Section1 from "./sections/Accommodation_Section1";
import Accommodation_Section2 from "./sections/Accommodation_Section2";
import Accommodation_Section3 from "./sections/Accommodation_Section3";
import Accommodation_Section4 from "./sections/Accommodation_Section4";
import Accommodation_Section5 from "./sections/Accommodation_Section5";
import Accommodation_Section6 from "./sections/Accommodation_Section6";

function AccommodationCleaning() {
  usePageMeta({
    title: "Accommodation Cleaning Services Ireland | Spechs",
    description: "Specialist cleaning for hotels, B&Bs, and rental properties across Ireland.",
    canonical: "https://www.spechs.ie/cleaning/accommodation/",
  });
  return (
    <SubPageLayout title="Accommodation Cleaning">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Accommodation_Section1 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Accommodation_Section2 />
      </MKBox>
      {/* <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Accommodation_Section3 />
      </MKBox> */}
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Accommodation_Section4 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Accommodation_Section5 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Accommodation_Section6 />
      </MKBox>
    </SubPageLayout>
  );
}

export default AccommodationCleaning;
